// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 2363 ? "premiumcarousel.b422bc86" : chunkId) + "--" + {"2025":"6495850","2363":"e66bbec","5538":"c0ab1ab","8878":"b5df317"}[chunkId] + ".css";
};